<template>
  <div class="container">
    <h2 class="title">Formulario de Gastos/Ingresos</h2>
    <form @submit.prevent="guardarGasto" class="form">
      <div class="form-group">
        <label for="tipoGasto" class="label">Tipo de Gastos/Ingreso:</label>
        <select
          v-model="gastosPagos.tipoGasto"
          id="tipoGasto"
          class="select"
          required
          @change="ajustarTipoGasto"
        >
          <option value="">Seleccione...</option>
          <option value="Nomina">Nómina</option>
          <option value="Publicidad">Publicidad</option>
          <option value="Prestamos">Préstamos</option>
          <option value="Pagos">Pagos</option>
          <option value="Proveedores">Proveedores</option>
          <option value="Aliados">Aliados</option>
          <option value="Compras">Compras</option>
          <option value="GastoComun">Gasto Común</option>
          <option value="ventassin">Venta sin inventario</option>
        </select>
      </div>

      <div v-if="gastosPagos.tipoGasto === 'Nomina'" class="form-group">
        <label for="nombreEmpleado" class="label">Nombre del Empleado:</label>
        <select
          v-model="gastosPagos.nombreEmpleado"
          id="nombreEmpleado"
          class="select"
          @change="guardarCedulaEmpleado($event)"
          required
        >
          <option value="">Seleccione...</option>
          <option
            v-for="empleado in nomina"
            :key="empleado.id"
            :value="empleado.nombre"
          >
            {{ empleado.nombre }}
          </option>
        </select>
      </div>

      <div v-if="gastosPagos.tipoGasto === 'Proveedores'" class="form-group">
        <label for="nombreProveedor" class="label">Nombre del Proveedor:</label>
        <select
          v-model="gastosPagos.nombreProveedor"
          id="nombreProveedor"
          class="select"
          @change="guardarIdProveedor($event)"
          required
        >
          <option value="">Seleccione...</option>
          <option
            v-for="proveedor in proveedores"
            :key="proveedor.id"
            :value="proveedor.nombre"
          >
            {{ proveedor.nombre }}
          </option>
        </select>
      </div>

      <div v-if="gastosPagos.tipoGasto === 'Aliados'" class="form-group">
        <label for="nombreAliado" class="label">Nombre del Aliado:</label>
        <select
          v-model="gastosPagos.nombreAliado"
          id="nombreAliado"
          class="select"
          @change="guardarIdAliado($event)"
          required
        >
          <option value="">Seleccione...</option>
          <option
            v-for="aliado in aliados"
            :key="aliado.id"
            :value="aliado.nombre"
          >
            {{ aliado.nombre }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label for="numeroFactura" class="label"
          >Número de Factura o Referencia:</label
        >
        <input
          type="text"
          v-model="gastosPagos.numeroFactura"
          id="numeroFactura"
          class="input"
          required
        />
      </div>
      <div class="form-group">
        <label for="fecha" class="label">Fecha:</label>
        <input
          type="date"
          v-model="gastosPagos.fecha"
          id="fecha"
          class="input"
          required
        />
      </div>

      <div class="form-group">
        <label for="concepto" class="label">Gastos/Ingreso:</label>
        <select
          v-model="gastosPagos.concepto"
          id="concepto"
          class="select"
          required
          @change="handleConceptChange"
        >
          <option value="">Seleccione...</option>
          <option value="Ingreso">Ingreso</option>
          <option value="Gasto">Gasto</option>
        </select>
      </div>

      <div class="form-group">
        <label for="valor" class="label">Valor:</label>
        <span id="valor" class="input">{{ gastosPagos.valor }}</span>
      </div>

      <div class="form-group">
        <label for="observaciones" class="label">Observaciones:</label>
        <textarea
          v-model="gastosPagos.observaciones"
          id="observaciones"
          class="textarea"
          rows="4"
          cols="50"
        ></textarea>
      </div>
      <button type="submit" class="button">Guardar Gasto</button>
    </form>
  </div>
</template>
  
  <script>
import HttpService from "../../Servicios/HttpService";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      nomina: "",
      proveedores: "",
      aliados: "",
      gastosPagos: {
        tipoGasto: "",
        numeroFactura: "",
        fecha: new Date().toISOString().substr(0, 10),
        concepto: "",
        valor: "",
        observaciones: "",
        nombreEmpleado: "",
        cedulaEmpleado: "",
        nombreProveedor: "",
        idProveedor: "",
        efectivo: "",
        tarjeta: "",
        transferencia: "",
        nequi: "",
        nombreAliado: "",
        idAliado: "",
        nequiComercial: "",
      },
    };
  },

  mounted() {
    this.obtenerNomina();
    this.obtenerProveedores();
    this.obtenerAliados();
  },

  methods: {
    async handleConceptChange() {
      if (this.gastosPagos.concepto === "Gasto") {
        await this.showPaymentDetailsPrompt();
      }
    },
    async showPaymentDetailsPrompt() {
      const { value: formValues } = await Swal.fire({
        title: "Ingrese los detalles de Dinero",
        html: `
      <input id="efectivo" class="swal2-input" placeholder="Efectivo">
      <input id="nequi" class="swal2-input" placeholder="Nequi">
      <input id="nequiComercial" class="swal2-input" placeholder="Nequi Comercial">
      <input id="tarjeta" class="swal2-input" placeholder="Bancolombia">
      <input id="transferencia" class="swal2-input" placeholder="Otra Cuenta">
    `,
        focusConfirm: false,
        preConfirm: () => ({
          efectivo: document.getElementById("efectivo").value || "0",
          tarjeta: document.getElementById("tarjeta").value || "0",
          transferencia: document.getElementById("transferencia").value || "0",
          nequi: document.getElementById("nequi").value || "0",
          nequiComercial:
            document.getElementById("nequiComercial").value || "0",
        }),
      });
      // Si se obtuvieron valores del formulario, actualizar las propiedades de this.gastosPagos
      if (formValues) {
        this.gastosPagos.efectivo = formValues.efectivo;
        this.gastosPagos.tarjeta = formValues.tarjeta;
        this.gastosPagos.transferencia = formValues.transferencia;
        this.gastosPagos.nequi = formValues.nequi;
        this.gastosPagos.nequiComercial = formValues.nequiComercial;
        // Suma de los valores, asegurándote de parsear a números antes de sumar
        this.gastosPagos.valor =
          parseInt(formValues.efectivo) +
          parseInt(formValues.tarjeta) +
          parseInt(formValues.transferencia) +
          parseInt(formValues.nequiComercial) +
          parseInt(formValues.nequi);
      }
    },
    ajustarTipoGasto() {
      switch (this.gastosPagos.tipoGasto) {
        case "Aliados":
          this.gastosPagos.concepto = "Ingreso";

          this.showPaymentDetailsPrompt();
          break;
        case "Proveedores":
          this.gastosPagos.concepto = "Gasto";
          this.handleConceptChange();
          break;
        case "Nomina":
          this.gastosPagos.concepto = "Gasto";
          this.handleConceptChange();
          break;
        case "Publicidad":
          this.gastosPagos.concepto = "Gasto";
          this.handleConceptChange();
          break;
        case "Prestamos":
          this.gastosPagos.concepto = "Gasto";
          this.handleConceptChange();
          break;
        case "Pagos":
          this.gastosPagos.concepto = "Gasto";
          this.handleConceptChange();
          break;
        case "Compras":
          this.gastosPagos.concepto = "Gasto";
          this.handleConceptChange();
          break;
        case "GastoComun":
          this.gastosPagos.concepto = "Gasto";
          this.handleConceptChange();
          break;
        case "ventassin":
          this.gastosPagos.concepto = "Gasto";
          this.handleConceptChange();
          break;
        default:
          this.gastosPagos.concepto = "";
          break;
      }
    },
    obtenerNomina() {
      let payload = {
        accion: "obtenerNomina",
      };
      HttpService.obtenerConConsultas("reportes.php", payload).then(
        (transacciones) => {
          this.nomina = transacciones;
        }
      );
    },
    obtenerProveedores() {
      let payload = {
        accion: "obtenerProveedores",
      };
      HttpService.obtenerConConsultas("reportes.php", payload).then(
        (transacciones) => {
          this.proveedores = transacciones;
        }
      );
    },
    obtenerAliados() {
      let payload = {
        accion: "obtenerAliados",
      };
      HttpService.obtenerConConsultas("reportes.php", payload).then(
        (transacciones) => {
          this.aliados = transacciones;
        }
      );
    },
    guardarCedulaEmpleado(event) {
      const nombreEmpleado = event.target.value;
      const empleadoSeleccionado = this.nomina.find(
        (empleado) => empleado.nombre === nombreEmpleado
      );
      this.gastosPagos.nombreEmpleado = nombreEmpleado;
      this.gastosPagos.cedulaEmpleado = empleadoSeleccionado.cedula;
    },
    guardarIdAliado(event) {
      const selectedAliado = this.aliados.find(
        (aliado) => aliado.nombre === event.target.value
      );
      if (selectedAliado) {
        this.gastosPagos.idAliado = selectedAliado.id;
      }
    },
    guardarIdProveedor(event) {
      const nombreProveedor = event.target.value;
      const proveedorSeleccionado = this.nomina.find(
        (empleado) => empleado.nombre === nombreProveedor
      );
      this.gastosPagos.nombreEmpleado = nombreProveedor;
      this.gastosPagos.cedulaEmpleado = proveedorSeleccionado.id;
    },
    guardarGasto() {
      console.log(this.gastosPagos);
      let payload = {
        accion: "registrarGastosPagos",
        gastosPagos: this.gastosPagos,
      };
      HttpService.registrar("reportes.php", payload).then((registrado) => {
        if (registrado) {
          Swal.fire({
            title: "Registro de formulario",
            text: "Registrado",
            icon: "success",
            confirmButtonText: "Aceptar",
          }).then(() => {
            window.location.reload();
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.title {
  text-align: center;
  margin-bottom: 20px;
}

.form {
  display: flex;
  flex-direction: column;
}

.form-group {
  margin-bottom: 15px;
}

.label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.select,
.input,
.textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.button {
  width: 100%;
  padding: 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.button:hover {
  background-color: #45a049;
}
</style>
